import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const HeaderContainer = styled.header`
  background: transparent;
  padding: ${theme.spacing.lg} 0;
  text-align: center;
  position: relative;
  
  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.md} 0;
  }
`;

const RestaurantName = styled.h1`
  font-size: ${theme.fontSizes['3xl']};
  font-weight: 800;
  margin: 0;
  color: ${theme.colors.text.primary};
  text-align: center;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.8);
  letter-spacing: -0.02em;
  line-height: 1.2;
  
  @media (max-width: ${theme.breakpoints.sm}) {
    font-size: ${theme.fontSizes['2xl']};
  }
  
  @media (max-width: ${theme.breakpoints.xs}) {
    font-size: ${theme.fontSizes.xl};
  }
`;

export const Header = ({ restaurant }) => {
  return (
    <HeaderContainer>
      <RestaurantName>{restaurant.name}</RestaurantName>
    </HeaderContainer>
  );
};
